// Checkbox selection for index tables. The component must define a `bulkSelectableRecords`
// computed property returning the records shown on the current page.
export default {
  data() {
    return {
      selectedRecords: []
    }
  },

  computed: {
    allRecordsSelected() {
      return this.bulkSelectableRecords.length > 0 && this.selectedRecords.length === this.bulkSelectableRecords.length
    }
  },

  watch: {
    // Clear the selection when the page, search or per-page changes so nothing off screen gets deleted.
    bulkSelectableRecords() {
      this.selectedRecords = []
    }
  },

  methods: {
    isRecordSelected(record) {
      return this.selectedRecords.some(r => r.id === record.id)
    },

    toggleSelectAllRecords(event) {
      this.selectedRecords = event.target.checked ? [...this.bulkSelectableRecords] : []
    },

    toggleRecordSelection(record) {
      const index = this.selectedRecords.findIndex(r => r.id === record.id)
      if (index === -1) {
        this.selectedRecords.push(record)
      } else {
        this.selectedRecords.splice(index, 1)
      }
    },

    clearRecordSelection() {
      this.selectedRecords = []
    }
  }
}
